import { styled, css, useTheme } from '@vebox/etui-system';
import '../utilities/format-ms.js';
import '../utilities/create-transition.js';
import { useContext, useState, createElement } from 'react';
import '../utilities/get-styleprop.js';
import { a as _objectSpread2 } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';
import Accordion from '../Accordion/Accordion.js';
import '../Accordion/AccordionSection.js';
import '../H5/H5.js';
import '../Svg-0180d7b5.js';
import Icon from '../Icon/Icon.js';
import '@vebox/etui-icons';
import { icons } from '../Icon/icons.js';
import '../Icon/helper.js';
import '../Accordion/utils/focus.js';
import '@vebox/etui-colors';
import 'react-spring/renderprops.cjs';
import '../Badge/Badge.js';
import '../ClickOutside/ClickOutside.js';
import '../Tooltip/Tooltip.js';
import Button from '../Button/Button.js';
import '../Chip/Chip.js';
import 'lodash.isnil';
import { FilterPanelTabs, getTotalNumberOfFilters } from './utils.js';
import './state/constants.js';
import { dismissFilters, saveFilters } from './state/actions.js';
import FilterPanelContext from './FilterPanelContext.js';
import Tabs from '../Tabs/Tabs.js';
import '../Tabs/TabsList.js';
import '../Tabs/Tab.js';
import '../ScrollingMenu/defaultSettings.js';
import '../ScrollingMenu/utils/index.js';
import '../ScrollingMenu/InnerWrapper.js';
import '../ScrollingMenu/ScrollingMenu.js';
import '../ScrollingMenu/ArrowWrapper.js';
import './Group/GroupTitle.js';
import './Group/Group.js';
import './SummarySection/SummarySectionChip.js';
import './SummarySection/FilterChips.js';
import SummarySection from './SummarySection/SummarySection.js';

const FiltersHeader = styled(Div)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-self: flex-start;
  width: 100%;
  height: 60px;
  ${({
  theme
}) => css`
    padding: ${theme.spacing.sm}px ${theme.spacing.md}px;
    background: ${theme.palette.grey[20]};
  `};
`;

const FiltersFooter = styled(Div)`
  display: flex;
  align-items: center;
  align-self: flex-end;
  justify-content: right;
  width: 100%;
  height: 60px;
  ${({
  theme
}) => css`
    padding: ${theme.spacing.sm}px ${theme.spacing.md}px;
    border-top: 1px solid ${theme.palette.divider};
    background: ${theme.palette.common.white};
  `};
`;

const FiltersContent = styled(Div)`
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
`;

const FiltersWrapper = styled(Div)`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 370px;
`;

const FilterPanelContent = ({
  title,
  children,
  noFiltersSummaryLabel,
  componentLabels,
  summaryFieldsMetadata,
  styles = {},
  useTabs,
  showHeader = true,
  showSummary = true,
  showCancelButton = true
}) => {
  var _componentLabels$tabs, _componentLabels$summ, _componentLabels$summ2, _styles$controls, _styles$controls2, _styles$controls2$can, _componentLabels$cont, _styles$controls3, _styles$controls4, _styles$controls4$app, _componentLabels$cont2;
  const theme = useTheme();
  const {
    state,
    dispatch
  } = useContext(FilterPanelContext);
  const [selectedTab, setSelectedTab] = useState(FilterPanelTabs.BASIC);
  const handleCloseDrawer = () => {
    dispatch(dismissFilters());
  };
  const handleApplyFilters = () => {
    dispatch(saveFilters());
  };
  const totalFilters = getTotalNumberOfFilters(state.toBeAppliedFilters);
  return /*#__PURE__*/createElement(FiltersWrapper, styles.wrapper, showHeader && /*#__PURE__*/createElement(FiltersHeader, styles.header, /*#__PURE__*/createElement(Div, {
    display: "flex",
    alignItems: "center"
  }, /*#__PURE__*/createElement(Icon, {
    glyph: icons.FILTER,
    size: 32
  }), title && /*#__PURE__*/createElement(Div, {
    ml: `${theme.spacing.sm}px`
  }, title.toUpperCase())), /*#__PURE__*/createElement(Div, {
    cursor: "pointer",
    onClick: handleCloseDrawer
  }, /*#__PURE__*/createElement(Icon, {
    glyph: icons.CLOSE,
    size: 32
  }))), /*#__PURE__*/createElement(FiltersContent, styles.content, useTabs && /*#__PURE__*/createElement(Tabs, {
    value: selectedTab,
    onChange: value => setSelectedTab(value),
    styles: {
      tabsList: {
        innerWrapper: {
          width: 'auto'
        }
      }
    }
  }, /*#__PURE__*/createElement(Tabs.Tab, {
    tab: `${(componentLabels === null || componentLabels === void 0 ? void 0 : (_componentLabels$tabs = componentLabels.tabs) === null || _componentLabels$tabs === void 0 ? void 0 : _componentLabels$tabs.basic) || 'Basic filters'} (${totalFilters})`,
    value: FilterPanelTabs.BASIC
  })), /*#__PURE__*/createElement(Accordion, null, showSummary && /*#__PURE__*/createElement(SummarySection, {
    filters: state.toBeAppliedFilters,
    noFiltersSummaryLabel: noFiltersSummaryLabel,
    clearAllLabel: componentLabels === null || componentLabels === void 0 ? void 0 : (_componentLabels$summ = componentLabels.summary) === null || _componentLabels$summ === void 0 ? void 0 : _componentLabels$summ.clearAll,
    title: componentLabels === null || componentLabels === void 0 ? void 0 : (_componentLabels$summ2 = componentLabels.summary) === null || _componentLabels$summ2 === void 0 ? void 0 : _componentLabels$summ2.title,
    fieldsMetadata: summaryFieldsMetadata
  }), children)), /*#__PURE__*/createElement(FiltersFooter, styles.footer, showCancelButton && /*#__PURE__*/createElement(Button, {
    onClick: handleCloseDrawer,
    variant: "default",
    block: true,
    styles: _objectSpread2(_objectSpread2({}, (_styles$controls = styles.controls) === null || _styles$controls === void 0 ? void 0 : _styles$controls.cancel), {}, {
      root: _objectSpread2({
        minWidth: '95px',
        height: '40px',
        px: `${theme.spacing.xlg}px`,
        border: `2px solid ${theme.palette.text.primary}`
      }, (_styles$controls2 = styles.controls) === null || _styles$controls2 === void 0 ? void 0 : (_styles$controls2$can = _styles$controls2.cancel) === null || _styles$controls2$can === void 0 ? void 0 : _styles$controls2$can.root)
    })
  }, (componentLabels === null || componentLabels === void 0 ? void 0 : (_componentLabels$cont = componentLabels.controls) === null || _componentLabels$cont === void 0 ? void 0 : _componentLabels$cont.cancel) || 'Cancel'), /*#__PURE__*/createElement(Button, {
    variant: "primary",
    onClick: handleApplyFilters,
    block: true,
    styles: _objectSpread2(_objectSpread2({}, (_styles$controls3 = styles.controls) === null || _styles$controls3 === void 0 ? void 0 : _styles$controls3.apply), {}, {
      root: _objectSpread2({
        minWidth: '95px',
        px: `${theme.spacing.xlg}px`,
        height: '40px',
        ml: `${theme.spacing.lg}px`
      }, (_styles$controls4 = styles.controls) === null || _styles$controls4 === void 0 ? void 0 : (_styles$controls4$app = _styles$controls4.apply) === null || _styles$controls4$app === void 0 ? void 0 : _styles$controls4$app.root)
    })
  }, (componentLabels === null || componentLabels === void 0 ? void 0 : (_componentLabels$cont2 = componentLabels.controls) === null || _componentLabels$cont2 === void 0 ? void 0 : _componentLabels$cont2.apply) || 'Apply filter')));
};

export default FilterPanelContent;
